import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { UsersService } from 'src/app/core/services/users/users.service';

@Component({
  selector: 'app-user-list-modal',
  templateUrl: './user-list-modal.component.html',
  styleUrls: ['./user-list-modal.component.scss']
})
export class UserListModalComponent implements OnInit, OnChanges {
  @Input() accessAcounIds?: string[];
  accessAcountList: any = [];
  allAccessAcountList: any = [];
  isModal: boolean = false;
  isLoading: boolean = false;
  searchValue: FormControl = new FormControl('')
  constructor(
    @Optional() public dialogRef: MatDialogRef<UserListModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _loaderService: LoaderService,
    private _userService: UsersService
  ) {
    this.isModal = !!this.dialogRef;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['accessAcounIds']?.currentValue) {
      this.fetchUserDetails(changes['accessAcounIds']?.currentValue);
    }
  }

  ngOnInit(): void {
    const ids = this.data?.accessAcounIds || this.accessAcounIds;
    this.fetchUserDetails(ids);
    this.searchValue.valueChanges.pipe(distinctUntilChanged(), debounceTime(400)).subscribe({
      next: (res) => {
        this.accessAcountList = this.allAccessAcountList.filter((item) => {
          const searchValue = res.toLowerCase();
          return (item.userName).toLowerCase().includes(searchValue) || (item?.roles?.name.toLowerCase().includes(searchValue))
        })
      }
    })
  }

  clearSearch() {
    this.searchValue.setValue('');
    this.searchValue.updateValueAndValidity();
  }

  fetchUserDetails(ids) {
    if (ids) {
      this.isLoading = true;
      //this._loaderService?.showLoader();
      this._userService
        .getUserById(ids)
        .subscribe(
          (res) => {
            if (res?.statusCode === 200 && res?.data?.length > 0)
              this.accessAcountList = res?.data?.map((item) => ({
                ...item,
                userName: `${item?.userDetails?.firstName} ${item?.userDetails?.lastName}`,
                userId: item?.id
              }));
            this.allAccessAcountList = this.accessAcountList;
            this.isLoading = false;
            //this._loaderService?.hideLoader();
          },
          (err) => {
            this.isLoading = false;
            //this._loaderService?.hideLoader();
          }
        );
    }
  }

  switchUser(account) {
    this.dialogRef.close(account);
  }
}
